const MOBILE_KEY = "mobileNumber";
const CHECK_IN_MESSAGE_KEY = "checkInMessage";

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
};

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

export const getMobileNumber = () => {
  return localStorage.getItem(MOBILE_KEY) || getCookie(MOBILE_KEY) || "";
};

export const saveMobileNumber = (mobile) => {
  localStorage.setItem(MOBILE_KEY, mobile);
  setCookie(MOBILE_KEY, mobile, 365);
};

export const getCheckInMessage = () => {
  return localStorage.getItem(CHECK_IN_MESSAGE_KEY) || "";
};

export const saveCheckInMessage = (message) => {
  localStorage.setItem(CHECK_IN_MESSAGE_KEY, message);
};
